import { ActionMenu } from '@dittolive/anvil'
import React from 'react'

type Props = {
  onSelectForEdit: () => void
  onSelectForDeletion: () => void
}

export default function WebhookActionMenu({
  onSelectForEdit,
  onSelectForDeletion,
}: Props) {
  return (
    <ActionMenu
      items={[
        { label: 'Edit Webhook', onClick: onSelectForEdit },
        { label: 'Delete Webhook', onClick: onSelectForDeletion },
      ]}
    />
  )
}
